import { render } from "./DashboardAppNav.vue?vue&type=template&id=5b29d764"
import script from "./DashboardAppNav.vue?vue&type=script&lang=js"
export * from "./DashboardAppNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__